import {IoWarning} from "react-icons/io5";
import GenericModal from "../../../../utils/GenericModal";
import {useEffect, useState} from "react";
import {setBottomBarError} from "../../../../utils/Functions";
import api from "../../../../utils/api";

export default function ChangeInferenceSettingsModal({modifiedKeys, toggleMe, saveConfiguration, dispatch}) {
    const completionsModelModified = modifiedKeys.includes("completions_model");
    const teiModelModified = modifiedKeys.includes("tei_model");
    const questionsEnabledModified = modifiedKeys.includes("questions_enabled");
    const documentsUploadEnabledModified = modifiedKeys.includes("documents_upload_enabled");

    const [companiesWithRequestsDerogation, setCompaniesWithRequestsDerogation] = useState([]);
    const [companiesWithDocumentsDerogation, setCompaniesWithDocumentsDerogation] = useState([]);

    useEffect(() => {
        async function getSpecialCompanies() {
            try {
                const response = await api.get("/company/all/special-companies");
                setCompaniesWithRequestsDerogation(response.data.filter(element => element.questions_enabled !== null));
                setCompaniesWithDocumentsDerogation(response.data.filter(element => element.documents_upload_enabled !== null));
            } catch (e) {
                setBottomBarError(dispatch, e);
            }
        }

        getSpecialCompanies();
    }, []);


    return <GenericModal
        className="w-1/2 xl:w-1/3 2xl:w-1/4 text-base text-black rounded-lg"
        showCloseButton={true}
        exitClick={true}
        toggleMe={toggleMe}
    >
        <div className="font-semibold w-full text-left px-4 py-3 border-b text-sm flex items-end gap-1">
            <IoWarning className="text-red-400 w-5 h-5"/>Modification de la configuration de l'inférence
        </div>
        <div className="flex flex-col gap-4 p-8 text-justify">
            <p><b>ATTENTION ! </b>Vous êtes sur le point de <b>changer les paramètres</b> utilisés pour <b>toutes les entreprises</b>, hormis celles qui ont
                des paramètres personnalisés.</p>
            {(questionsEnabledModified && companiesWithRequestsDerogation.length > 0) && (<div>
                Les entreprises ayant une <b>dérogation</b> sur les <b>questions</b> sont : <br/>
                <ul className="ml-5 list-disc">
                    {companiesWithRequestsDerogation.map((company) => (
                        <li key={company.name}>
                            <div className="flex gap-5">
                                {company.name}
                                {company.questions_enabled
                                    ? <div className="text-figmaColors-positiveFeedback">Activées</div>
                                    : <div className="text-figmaColors-warningFeedback">Désactivées</div>
                                }
                            </div>
                        </li>
                    ))}
                </ul>
            </div>)}
            {(documentsUploadEnabledModified && companiesWithDocumentsDerogation.length > 0) && (<div>
                Les entreprises ayant une <b>dérogation</b> sur l'ajout de <b>documents</b> sont : <br/>
                <ul className="ml-5 list-disc">
                    {companiesWithDocumentsDerogation.map((company) => (
                        <li key={company.name}>
                            <div className="flex gap-5">
                                {company.name}
                                {company.documents_upload_enabled
                                    ? <div className="text-figmaColors-positiveFeedback">Activés</div>
                                    : <div className="text-figmaColors-warningFeedback">Désactivés</div>
                                }
                            </div>
                        </li>
                    ))}
                </ul>
            </div>)}
            {(teiModelModified || completionsModelModified) && (<>
                    <p>
                        Le changement de modèle d'inférence peut impliquer un <b>changement dans le comportement de l'IA et dans les réponses générées.</b>
                    </p>
                    {teiModelModified && (
                        <p>
                            Le changement de modèle de vectorisation implique également la <b>régénération des vecteurs</b> pour toutes les entreprises, ce qui
                            entrainera une <b>indisponibilité du chatbot</b> pendant un certain temps et une <b>utilisation accrue de tokens</b>.
                        </p>
                    )}
                </>
            )}

            Êtes vous sûr de vouloir continuer ?

        </div>

        <div className="flex w-full justify-end gap-4 py-2 border-t px-4">
            <button onClick={toggleMe} className="rounded border bg-white text-black text-sm font-light py-1 px-2">
                Annuler
            </button>
            <button
                onClick={async () => {
                    if (await saveConfiguration()) {
                        toggleMe();
                    }
                }}
                className="rounded bg-gray-600 hover:bg-gray-700 text-white text-sm py-1 px-2 transform duration-300"
            >
                Continuer
            </button>
        </div>
    </GenericModal>;
}
